"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Form = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _vuePropertyDecorator = require("vue-property-decorator");

var _formItem = require("./formItem");

var _domForm = require("./core/domForm");

var _dec, _dec2, _dec3, _dec4, _dec5, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _temp;

function _createSuper(Derived) { return function () { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Form = (_dec = (0, _vuePropertyDecorator.Provide)(), _dec2 = (0, _vuePropertyDecorator.Prop)({
  default: function _default() {}
}), _dec3 = (0, _vuePropertyDecorator.Prop)({
  default: 'horizontal'
}), _dec4 = (0, _vuePropertyDecorator.Prop)(), _dec5 = (0, _vuePropertyDecorator.Watch)('initData', {
  immediate: true
}), (0, _vuePropertyDecorator.Component)(_class = (_class2 = (_temp = /*#__PURE__*/function (_VueComponent) {
  (0, _inherits2.default)(Form, _VueComponent);

  var _super = _createSuper(Form);

  function Form() {
    var _this;

    (0, _classCallCheck2.default)(this, Form);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _initializerDefineProperty2.default)(_this, "form", _descriptor, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "initData", _descriptor2, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "layout", _descriptor3, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "handleSubmit", _descriptor4, (0, _assertThisInitialized2.default)(_this));
    _this.loading = false;
    return _this;
  }

  (0, _createClass2.default)(Form, [{
    key: "initDataChange",
    value: function initDataChange(initData) {
      this.form.setInitValues(initData || {});
    }
  }, {
    key: "emitChange",
    value: function emitChange(values) {
      this.$emit('itemChange', values);
    }
  }, {
    key: "doSubmit",
    value: function doSubmit(handleSubmit) {
      var _this2 = this;

      var form = this.form;

      if (this.loading) {
        return;
      }

      this.loading = true;
      form.validateFields(function (values, errs) {
        if (errs) {
          _this2.loading = false;
          return;
        }

        _this2.$emit('submit', values);

        if (handleSubmit) {
          handleSubmit(values).finally(function () {
            _this2.loading = false;
          });
        } else {
          _this2.loading = false;
        }
      });
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(e) {
      if (e) {
        e.preventDefault();
      }

      var handleSubmit = this.handleSubmit,
          doSubmit = this.doSubmit;
      doSubmit(handleSubmit);
    }
  }, {
    key: "render",
    value: function render(h) {
      var layout = this.layout,
          onSubmit = this.onSubmit;
      var child = this.$slots.default;
      var formProps = {
        class: (0, _defineProperty2.default)({
          'mh-form': true
        }, "mh-form-layout-".concat(layout), !!layout),
        on: {
          submit: onSubmit
        }
      };
      return h('form', formProps, child);
    }
  }], [{
    key: "install",
    value: function install(context) {
      context.component('mh-form', this);
      context.component('mh-form-item', _formItem.FormItem);
    }
  }]);
  return Form;
}(_vuePropertyDecorator.Vue), _temp), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "form", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return (0, _domForm.createForm)(this);
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "initData", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "layout", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "handleSubmit", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "initDataChange", [_dec5], Object.getOwnPropertyDescriptor(_class2.prototype, "initDataChange"), _class2.prototype)), _class2)) || _class);
exports.Form = Form;